import set from 'lodash/set';
import { useCallback } from 'react';
import * as Y from 'yjs';

import { ActivityThemeStyles, defaultActivityThemeStyles } from 'external-modules/ui';

import { useParentTheme } from './useParentTheme';
import { getThemePropertyValue } from '@/contentObjects/Root/ActivityThemeStylesUtils';
import { getRootMap, useObservedProperty } from '@/utils/yjs';

export function useActivityThemeStylesProperty<T = string>(
  document: Y.Doc,
  path: string,
  globalPath?: string,
  partialGlobalPath?: string
) {
  const { data: parentTheme } = useParentTheme();

  const rootMap = getRootMap(document);
  const [activityThemeStyles, setActivityThemeStyles] = useObservedProperty<ActivityThemeStyles>(
    rootMap,
    'activityThemeStyles'
  );
  const handleSet = useCallback(
    (newValue: T) => {
      setActivityThemeStyles(prevTheme => set(structuredClone(prevTheme), path, newValue));
    },
    [setActivityThemeStyles, path]
  );

  const finalProperty = getThemePropertyValue(
    activityThemeStyles,
    parentTheme?.styles,
    defaultActivityThemeStyles,
    path,
    globalPath,
    partialGlobalPath
  );

  return [finalProperty as T, handleSet] as const;
}
